import React from 'react';
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function Profile() {
  const navigate = useNavigate();
  return (
    <Container className="py-4">
      <h2 className="mb-4">Mein Profil</h2>
      
      <Row>
        <Col md={8}>
          <Card className="mb-4">
            <Card.Body>
              <h5 className="mb-4">Persönliche Informationen</h5>
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Vorname des Kindes</Form.Label>
                      <Form.Control type="text" placeholder="Max" defaultValue="Max" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Alter</Form.Label>
                      <Form.Control type="number" placeholder="6" defaultValue="6" />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Form.Group className="mb-3">
                  <Form.Label>E-Mail der Eltern</Form.Label>
                  <Form.Control type="email" placeholder="eltern@beispiel.de" defaultValue="eltern@beispiel.de" />
                </Form.Group>
                
                <Form.Group className="mb-4">
                  <Form.Label>Besondere Hinweise</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows={3} 
                    placeholder="Zusätzliche Informationen über Sprachschwierigkeiten..."
                  />
                </Form.Group>
                
                <Button 
                  variant="primary"
                  style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}
                >
                  Änderungen speichern
                </Button>
              </Form>
            </Card.Body>
          </Card>
          
          <Card>
            <Card.Body>
              <h5 className="mb-4">Fortschrittsübersicht</h5>
              <Row>
                <Col md={4} className="text-center mb-3">
                  <div className="display-4 text-primary">24</div>
                  <p className="text-muted">Gespielte Spiele</p>
                </Col>
                <Col md={4} className="text-center mb-3">
                  <div className="display-4 text-success">18</div>
                  <p className="text-muted">Erfolgreiche Übungen</p>
                </Col>
                <Col md={4} className="text-center mb-3">
                  <div className="display-4 text-info">3</div>
                  <p className="text-muted">Tage in Folge</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <h5 className="mb-3">Abonnement</h5>
              <p className="mb-2">
                <strong>Aktueller Plan:</strong> Vierteljährlich
              </p>
              <p className="mb-3">
                <strong>Nächste Abrechnung:</strong> 01.03.2024
              </p>
              <Button 
                variant="outline-secondary" 
                size="sm"
                onClick={() => navigate('/subscription')}
              >
                Plan verwalten
              </Button>
            </Card.Body>
          </Card>
          
          <Card>
            <Card.Body>
              <h5 className="mb-3">Ausgewählte Silben</h5>
              <div className="d-flex flex-wrap gap-2">
                <span className="badge bg-primary">KA</span>
                <span className="badge bg-primary">SA</span>
                <span className="badge bg-primary">LA</span>
                <span className="badge bg-primary">RA</span>
              </div>
              <Button 
                variant="link" 
                className="mt-3 p-0"
                style={{ color: 'var(--primary-color)' }}
              >
                Silben ändern
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Profile;